import React from 'react';
import { WhisperSpinner } from '@revenuewell/ui-progress';
import { useProgress } from '../../hooks/progress/progress';

/* eslint-disable-next-line */
export interface AppSpinnerProps {}

export function AppSpinner(props: React.PropsWithChildren<AppSpinnerProps>) {
    const { appSpinnerAction } = useProgress();

    return (
        <WhisperSpinner isLoading={appSpinnerAction != null} message={appSpinnerAction?.message} />
    );
}